import { MessageCircleQuestion } from "lucide-react";
// eslint-disable-next-line no-unused-vars
const _unused = MessageCircleQuestion;

export default function Footer() {
    return (
        <footer className="mt-20 border-t border-slate-200 bg-white">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid gap-10 sm:grid-cols-3">
                <div>
                    <img
                        src="/brand-header.png"
                        alt="CondominioNow — L'esperto risponde"
                        className="h-[60px] w-auto object-contain"
                    />
                    <p className="mt-4 text-sm text-slate-600 leading-relaxed max-w-sm">
                        Il servizio informativo gratuito di <strong>Nowgestioni S.r.l.</strong>{" "}
                        Risposte a chi vive il condominio, scritte da professionisti reali. Nessuna
                        intelligenza artificiale.
                    </p>
                </div>
                <div>
                    <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">
                        Naviga
                    </div>
                    <ul className="mt-4 space-y-2 text-sm text-slate-600">
                        <li><a href="/faq" className="hover:text-primary transition">Domande veloci</a></li>
                        <li><a href="/codice-civile" className="hover:text-primary transition">Codice Civile</a></li>
                        <li><a href="/risorse" className="hover:text-primary transition">Servizi offerti da NowGestioni S.r.l.</a></li>
                        <li><a href="/chi-siamo" className="hover:text-primary transition">Chi siamo</a></li>
                    </ul>
                </div>
                <div>
                    <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">
                        Legale
                    </div>
                    <ul className="mt-4 space-y-2 text-sm text-slate-600">
                        <li><a href="/privacy" className="hover:text-primary transition" data-testid="footer-privacy">Privacy Policy</a></li>
                        <li><a href="/termini" className="hover:text-primary transition" data-testid="footer-terms">Termini di servizio</a></li>
                        <li><a href="/cookie" className="hover:text-primary transition" data-testid="footer-cookie">Cookie</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-slate-100">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex flex-wrap items-center justify-between gap-2">
                    <span>© {new Date().getFullYear()} Nowgestioni S.r.l. — CondominioNow</span>
                    <span className="uppercase tracking-widest">Servizio gratuito · MVP</span>
                </div>
            </div>
        </footer>
    );
}
